import { monthLabel } from '../lib/format';
import { shiftPeriod, type Period } from '../lib/period';

/** Intestazione con mese corrente e frecce avanti/indietro. */
export function MonthSwitcher({
  period,
  onChange,
}: {
  period: Period;
  onChange: (p: Period) => void;
}) {
  return (
    <div className="mb-4 flex items-center justify-between">
      <button
        type="button"
        onClick={() => onChange(shiftPeriod(period, -1))}
        aria-label="Mese precedente"
        className="flex h-11 w-11 items-center justify-center rounded-full text-2xl text-accent transition active:scale-95"
      >
        ‹
      </button>
      <h2 className="text-[1.0625rem] font-semibold">{monthLabel(period.year, period.month)}</h2>
      <button
        type="button"
        onClick={() => onChange(shiftPeriod(period, 1))}
        aria-label="Mese successivo"
        className="flex h-11 w-11 items-center justify-center rounded-full text-2xl text-accent transition active:scale-95"
      >
        ›
      </button>
    </div>
  );
}
